import SubLanding from "@/components/SubLanding";
export default function WisdomCoach() { return <SubLanding slug="wisdom-coach" />; }
